export const INFO = "redux/INFO";
export const INFO_REQUEST = "redux/INFO_REQUEST";
export const INFO_REQUEST_SUCCESS = "redux/INFO_REQUEST_SUCCESS";
export const INFO_REQUEST_FAILURE = "redux/INFO_REQUEST_FAILURE";


